/**
 * BasicInfoSection Component
 * 협력사 기본 정보 표시 섹션
 */
import React from "react";
import { SupplierInfo } from "../types/supplierInfo.types";
import { SaveIcon } from '@/shared/components/icons/Icons';
import { getItem } from '@/shared/utils/storage';

interface BasicInfoSectionProps {
  supplierInfo: SupplierInfo;
  saving: boolean;
  onFieldChange: (field: keyof SupplierInfo, value: string) => void;
  onSave: () => void;
}

const BasicInfoSection: React.FC<BasicInfoSectionProps> = ({
  supplierInfo,
  saving,
  onFieldChange,
  onSave,
}) => {
  // 사용자 타입 확인 (관리자만 협력사 타입 수정 가능)
  const userType = getItem<string>('USER_TYPE');
  const isAdmin = userType === 'HEADQUARTERS';
  return (
    <div className="supplier-section">
      <h2 className="section-title">기본 정보</h2>
      <div className="info-list">
          {/* 편집 가능한 필드: 휴대폰 번호 */}
          <div className="info-row">
              <span className="info-label">휴대폰 번호:</span>
              <span className="info-value">{supplierInfo.mobilePhone}</span>
          </div>
          <div className="info-row">
              <span className="info-label">협력사 주소:</span>
              <input
                  type="text"
                  className="info-input"
                  value={supplierInfo.address || ""}
                  onChange={(e) => onFieldChange("address", e.target.value)}
                  placeholder="협력사 주소를 입력하세요"
              />
          </div>
          <div className="info-row">
              <span className="info-label">협력사명:</span>
              <span className="info-value">{supplierInfo.supplierName}</span>
          </div>
          <div className="info-row">
              <span className="info-label">협력사 아이디:</span>
              <span className="info-value">{supplierInfo.supplierId}</span>
          </div>
          <div className="info-row">
              <span className="info-label">협력사 등급:</span>
              <span className="info-value">
                {supplierInfo.supplierGrade || "-"}
          </span>
          </div>
          <div className="info-row">
            <span className="info-label">상태:</span>
            <span className="info-value">{supplierInfo.status}</span>
        </div>
          <div className="info-row">
            <span className="info-label">등록일:</span>
            <span className="info-value">{supplierInfo.registrationDate}</span>
        </div>
          <div className="info-row">
            <span className="info-label">운영종료일:</span>
            <span className="info-value">
              {supplierInfo.operationEndDate || "-"}
          </span>
        </div>
          <div className="info-row">
            <span className="info-label">전화번호:</span>
            <input
            type="text"
            className="info-input"
            value={supplierInfo.mobilePhone}
            onChange={(e) => onFieldChange("mobilePhone", e.target.value)}
            placeholder="휴대폰 번호를 입력하세요"
          />
        </div>
        <div className="info-row">
          <span className="info-label">협력사 타입:</span>
          {isAdmin ? (
            <select
              className="info-input"
              value={supplierInfo.suppType === '가맹' ? 'F' :
                     supplierInfo.suppType === '직영' ? 'D' :
                     supplierInfo.suppType === 'F' ? 'F' :
                     supplierInfo.suppType === 'D' ? 'D' : 'D'}
              onChange={(e) => {
                onFieldChange('suppType', e.target.value);
              }}
            >
              <option value="D">직영</option>
              <option value="F">가맹</option>
            </select>
          ) : (
            <span className="info-value">{supplierInfo.suppType}</span>
          )}
        </div>
        <div className="info-row">
          <span className="info-label">배달권역:</span>
          <span className="info-value">{supplierInfo.deliveryArea}</span>
        </div>
      </div>

      {/* 저장 버튼 */}
      <div className="section-actions">
        <button className="btn btn-primary" onClick={onSave} disabled={saving}>
          <SaveIcon width={16} height={16} />
          <span>{saving ? "저장 중..." : "저장"}</span>
        </button>
      </div>
    </div>
  );
};

export default BasicInfoSection;
